import { useParticipantsWithPastShifts } from '../../../../ui/features/shift/hooks/useParticipantsWithPastShifts';
export const useParticipantsWithPastShiftsTableDataProvider = (request, additionalData) => {
    var _a, _b;
    const { isLoading, shiftsParticipants, total, error, analytics, fetchShiftsParticipants } = useParticipantsWithPastShifts({
        filterData: additionalData.filterData,
        offset: (_a = request === null || request === void 0 ? void 0 : request.offset) !== null && _a !== void 0 ? _a : 0,
        limit: (_b = request === null || request === void 0 ? void 0 : request.limit) !== null && _b !== void 0 ? _b : 0,
    });
    const data = {
        filteredRowCount: total,
        rows: shiftsParticipants !== null && shiftsParticipants !== void 0 ? shiftsParticipants : [],
    };
    return {
        data,
        error,
        isLoading,
        reload: fetchShiftsParticipants,
        customBackendResponseData: {
            analytics: analytics !== null && analytics !== void 0 ? analytics : { totalPendingHours: 0 },
            total: total !== null && total !== void 0 ? total : 0,
        },
    };
};
